import { isConnectorId } from '#pplx/frontend/apps/ask/files/file-utils/fileUtils.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const computerCommandMenuItemSelectedEvent = EVENT_PAYLOAD;
export function getComputerMenuItemSelectedValue(item) {
    const { action } = item;
    switch (action.type) {
        case 'connector':
            return isConnectorId(action.source.id) ? action.source.id : 'custom';
        case 'skill':
            return action.selectableSkill.id;
        case 'ui_action':
            return action.actionId;
        case 'slash_command':
            return action.commandName;
        case 'plugin':
            return action.plugin.action.plugin_id;
        default:
            return assertUnreachableValue(action);
    }
}
//# sourceMappingURL=commandMenuEvents.js.map